// @flow

export const FEEDBACK_STATE = 'feedback';



// WEBPACK FOOTER //
// ./app/CaptureFeedback/constants.js